module.exports = __webpack_public_path__ + "static/img/lottery-nav-bg.c55b24f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/lottery-nav-bg.png
// module id = uAEc
// module chunks = 3